<template>
  <div>
    <dashboard-view />
  </div>
</template>

<script>
import DashboardView from '@/modules/dashboardModule/DashboardView'
export default {
    name: 'HomeTracking',
    components: {
        DashboardView
    }
}
</script>

<style lang="scss" scoped>

</style>
